//* import statements
import { useContext, Fragment } from "react";
import { AuthContext } from "./store/auth-context";

import "./App.css";
import Home from "./components/Home/Home";
import Header from "./components/Header/Header";
import Login from "./components/Login/Login";
import SignUp from "./components/SignUp/SignUp";

const App = () => {
  const appCtx = useContext(AuthContext);

  return (
    <Fragment>
      <Header />
      {appCtx.isLoggedIn && <Home />}
      {!appCtx.isLoggedIn && !appCtx.toSignUp && (
        <Login />
      )}
      {!appCtx.isLoggedIn && appCtx.toSignUp && (
        <SignUp />
      )}
    </Fragment>
  );
};

export default App;
